import {certmngConstants} from "../../constants";

const initialState = {
  CertmngList: {},
  isLoading: false,
  isFailure: false,
  isDelete: false,
  isSubmit: false,
  receiverList: [],
}

export default function certmng(state = initialState, action) {
  switch (action.type) {
      /***********
       증명서 신청 검색조건 변경
       ************/
    case certmngConstants.SELECT_SEARCH_REQUEST:
      return {
        ...state,
        selectInfo: action.payload
      }

    /*********
     증명서 신청 목록 조회
     **********/
    case certmngConstants.CERTMNG_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading
      }
    case certmngConstants.CERTMNG_SUCCESS:
      return {
        ...state,
        CertmngList: action.response.data?.payload,
        isDelete: false,
      }
    case certmngConstants.CERTMNG_FAILURE:
      return {
        ...state,
        isLoading: false,
        isFailure: true
      }

      /*********
       증명서 신청 상세 조회
       **********/
    case certmngConstants.DETAIL_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading
      }
    case certmngConstants.DETAIL_SUCCESS:
      return {
        ...state,
        certmngInfo: action.response.data?.payload,
        isFailure: false
      }
    case certmngConstants.DETAIL_FAILURE:
      return {
        ...state,
        isLoading: false,
        isFailure: true
      }

    /***********
     증명서 신청 상세 선택
     ************/
    case certmngConstants.SELECT_REQUEST:
      return {
        ...state,
        info: action.payload
      }

      /***********
       증명서 신청 히스토리 관리
       ************/
    case certmngConstants.CERTMNG_HISTORY:
      return {
        ...state,
        history: action.payload
      }

    default:
      return state
  }
}
